import React from "react";
import { visiblePageIndices } from "./utils";

export default function Pagination({ page, totalPages, totalItems, announcementsLength, itemsPerPage, onPageChange }) {
  if (announcementsLength === 0) return null;

  const startItem = (page - 1) * itemsPerPage + 1;
  const endItem = (page - 1) * itemsPerPage + announcementsLength;

  return (
    <div className="dark-card p-4 sm:p-6 animate-fade-in-up">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="text-sm text-gray-300" style={{ color: "#FFFFFF" }}>
          {totalItems != null ? (
            <>
              Показано{" "}
              <span className="font-medium" style={{ color: "#FFFFFF" }}>{startItem}–{endItem}</span>
              {" из "}
              <span className="font-medium" style={{ color: "#FFFFFF" }}>{totalItems.toLocaleString("ru-RU")}</span>
            </>
          ) : (
            <>
              На странице: <span className="font-medium" style={{ color: "#FFFFFF" }}>{announcementsLength}</span>
              {totalPages > 1 && <> · всего страниц: <span className="font-medium" style={{ color: "#FFFFFF" }}>{totalPages}</span></>}
            </>
          )}
          <span className="text-gray-500"> (стр. {page} / {totalPages})</span>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 sm:justify-end">
          <button
            type="button"
            onClick={() => onPageChange(1)}
            disabled={page <= 1}
            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white disabled:cursor-not-allowed opacity-50 disabled:opacity-50 transition-all"
            title="Первая страница"
            style={{ color: "#FFFFFF" }}
          >
            <svg className="h-5 w-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
            </svg>
            <span className="hidden sm:inline">В начало</span>
          </button>

          <button
            type="button"
            onClick={() => onPageChange(page - 1)}
            disabled={page <= 1}
            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white disabled:cursor-not-allowed disabled:opacity-40 transition-all"
            title="Предыдущая страница"
            style={{ color: "#FFFFFF" }}
          >
            <svg className="h-5 w-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Назад
          </button>

          <div className="flex flex-wrap items-center justify-center gap-1 px-1">
            {visiblePageIndices(page, totalPages, 5).map((pageNum) => (
              <button
                key={pageNum}
                type="button"
                onClick={() => onPageChange(pageNum)}
                className={`min-w-[2.5rem] rounded-lg px-3 py-2 text-sm font-medium transition-all ${
                  page === pageNum
                    ? "bg-gradient-to-r from-blue-500 to-purple-600 shadow-lg"
                    : "text-gray-300 hover:bg-gray-700 hover:text-white"
                }`}
                style={page === pageNum ? { color: "#FFFFFF" } : { color: "#FFFFFF" }}
              >
                {pageNum}
              </button>
            ))}
          </div>

          <button
            type="button"
            onClick={() => onPageChange(page + 1)}
            disabled={page >= totalPages}
            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white disabled:cursor-not-allowed disabled:opacity-40 transition-all"
            title="Следующая страница"
            style={{ color: "#FFFFFF" }}
          >
            Вперёд
            <svg className="h-5 w-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          <button
            type="button"
            onClick={() => onPageChange(totalPages)}
            disabled={page >= totalPages}
            className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-gray-300 hover:bg-gray-700 hover:text-white disabled:cursor-not-allowed opacity-50 disabled:opacity-50 transition-all"
            title="Последняя страница"
            style={{ color: "#FFFFFF" }}
          >
            <span className="hidden sm:inline">В конец</span>
            <svg className="h-5 w-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}